<section class="member-each-region" *ngIf="(serviceList$ | async)?.length">
  <ng-container *ngFor="let item of serviceList$ | async">
    <div class="box">
      <div class="box-topic">
        <div class="box-topic__heading">
          <span>
            {{ 'BECOME_OUR_PARTNER.MEMBER_EACH_REGION.HEADING_LAYOUT_1' | translate }}
            {{ item.data.totalPartners.iv }}+
            {{ 'BECOME_OUR_PARTNER.MEMBER_EACH_REGION.HEADING_LAYOUT_2' | translate }}
          </span>
        </div>
      </div>

      <div class="box-container">
        <ng-container *ngFor="let region of regions; let i = index">
          <div
            class="box-container__region"
            [ngClass]="{
              'has-v-divider-desktop': i < 3,
              'has-v-divider-tablet': i === 1 || i === 3,
              'has-h-divider-mobile': i < regions.length - 1
            }"
          >
            <div class="box-container__region--amount"
              ><span>{{ item.data[region.key].iv }}</span></div
            >
            <div class="box-container__region--name"
              ><span>{{ 'BECOME_OUR_PARTNER.MEMBER_EACH_REGION.REGION.' + region.label | translate }}</span>
            </div>
            <img
              class="box-container__region--image"
              [src]="
                'https://flowaccountcdn.com/new_landing/image/accountingfirm/become-our-partner/member-each-region/' +
                region.image +
                '.png'
              "
              loading="lazy"
              [alt]="region.image"
            />
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</section>
